import * as React from 'react';

import { BarcodeService } from 'root/apps/InventoryCountScanQueue/BarcodeService';

export const useBarcodeService = (
  accountID: string,
  employeeID: string,
  inventoryCountID: string
) => {
  const [barcodeService] = React.useState<BarcodeService>(
    new BarcodeService(accountID, employeeID, inventoryCountID)
  );
  React.useEffect(() => {
    return () => {
      barcodeService.closeConnection();
    };
  }, [barcodeService]);
  return barcodeService;
};
